import { WithCompletionStatus } from '@/components/general/buttons/WithCompletionStatus/WithCompletionStatus';
import { SaveButton } from '@/components/general/buttons/SaveButton/SaveButton';
import { ComponentPropsWithoutRef } from 'react';

type SaveButtonWithCompletionStatusProps = Pick<
    ComponentPropsWithoutRef<typeof SaveButton>,
    'id' | 'isSubmitting' | 'isDisabled' | 'label' | 'onClick'
> &
    Pick<
        ComponentPropsWithoutRef<typeof WithCompletionStatus>,
        'status' | 'resetStatus' | 'successMessage' | 'onlyResetStatusOnFail'
    >;

export const SaveButtonWithCompletionStatus = (props: SaveButtonWithCompletionStatusProps) => (
    <WithCompletionStatus
        status={props.status}
        resetStatus={props.resetStatus}
        successMessage={props.successMessage}
        onlyResetStatusOnFail={props.onlyResetStatusOnFail}
    >
        <SaveButton
            sx={{ minHeight: '2.5rem' }}
            id={props.id}
            isSubmitting={props.isSubmitting}
            label={props.label}
            onClick={props.onClick}
            isDisabled={props.isDisabled}
        />
    </WithCompletionStatus>
);
